import { createSlice, createSelector, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '@/store';
import { logout, loginAsync } from './authSlice';


interface UserPreferencesState {
  byScreenCode: Record<string, Record<string, unknown>>;
}

interface SetScreenPreferencesPayload {
  screenCode: string;
  preferences: Record<string, unknown>;
}

const initialState: UserPreferencesState = {
  byScreenCode: {},
};

const userPreferencesSlice = createSlice({
  name: 'userPreferences',
  initialState,
  reducers: {
    setScreenPreferences(state, action: PayloadAction<SetScreenPreferencesPayload>) {
      state.byScreenCode[action.payload.screenCode] = action.payload.preferences;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(logout, (state) => {
        state.byScreenCode = {};
      })
      .addCase(loginAsync.fulfilled, (state) => {
        state.byScreenCode = {};
      });
  },
});

export const { setScreenPreferences } = userPreferencesSlice.actions;
export default userPreferencesSlice.reducer;

// Selectors
export const selectUserPreferencesState = (state: RootState) => state.userPreferences;
export const selectScreenPreferences = (screenCode: string) =>
  createSelector(selectUserPreferencesState, (state) => state.byScreenCode[screenCode]);
